import * as runtypes from 'runtypes';

export const Oauth = runtypes.Record({
  accessToken: runtypes.String,
  createdAt: runtypes.Number,
  expiresIn: runtypes.Number
});

export type Oauth = runtypes.Static<typeof Oauth>;
